import { FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { IFormPros } from "./IFormProps";
import { IPageLink } from "../../../../base/models";

export const FormProperties = [
    { id: Property.SystemId, name: 'System Id', type: PropertyType.String },
    { id: Property.AutoSave, name: 'Auto Save', type: PropertyType.Boolean },
    { id: Property.PageLink, name: 'Page Link', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
]

export const useFormProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IFormPros>()
    const draftText = usePropertyDraftText({bindings, property: Property.Label})

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const systemId = bindings.getValue<string>(Property.SystemId);
        const autoSave = bindings.getValue<boolean>(Property.AutoSave);
        const pageLink = bindings.getValue<IPageLink>(Property.PageLink);
        const title = bindings.getValue<string>(Property.Tooltip);
    
        setProperties({ systemId, autoSave, pageLink, title })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
